<div class="profile-page">

  <!-- Back link -->
  <button type="button" class="profile-back" (click)="goBack()">
    <i class="pe-7s-angle-left"></i> Back to Dashboard
  </button>

  <!-- Two-column grid -->
  <div class="profile-grid">

    <!-- LEFT: Profile card -->
    <div class="profile-card">

      <div class="pc-hero">

        <!-- Hidden file input -->
        <input #fileInput type="file" accept="image/*" class="pc-file-input"
               (change)="onFileSelected($event)">

        <!-- Clickable avatar with camera overlay -->
        <div class="pc-avatar-wrap" (click)="openFilePicker()" title="Change photo">
          <div class="pc-avatar">
            <img *ngIf="profilePic" [src]="profilePic" alt="Profile" class="pc-avatar-img">
            <span *ngIf="!profilePic">{{ initial }}</span>
          </div>
          <div class="pc-avatar-overlay">
            <i class="pe-7s-camera"></i>
          </div>
        </div>

        <h2 class="pc-name">{{ user?.name || '—' }}</h2>
        <span class="pc-badge" [ngClass]="roleClass">{{ roleLabel }}</span>

        <button *ngIf="profilePic" type="button" class="pc-remove-photo" (click)="$event.stopPropagation(); removePhoto()">
          <i class="pe-7s-close-circle"></i> Remove photo
        </button>

      </div>

      <div class="pc-strip">

        <div class="pc-strip__item">
          <div class="pc-strip__icon"><i class="pe-7s-mail"></i></div>
          <span class="pc-strip__label">Email</span>
          <span class="pc-strip__value">{{ user?.email || '—' }}</span>
        </div>

        <div class="pc-strip__sep"></div>

        <div class="pc-strip__item">
          <div class="pc-strip__icon"><i class="pe-7s-shield"></i></div>
          <span class="pc-strip__label">Role</span>
          <span class="pc-strip__value" [ngClass]="'role-val--' + user?.role?.toLowerCase()">{{ roleLabel }}</span>
        </div>

        <ng-container *ngIf="user?.clientName">
          <div class="pc-strip__sep"></div>
          <div class="pc-strip__item">
            <div class="pc-strip__icon"><i class="pe-7s-home"></i></div>
            <span class="pc-strip__label">Organization</span>
            <span class="pc-strip__value">{{ user.clientName }}</span>
          </div>
        </ng-container>

      </div>

      <!-- Account info -->
      <div class="pc-info-section">
        <div class="pc-info-row">
          <span class="pc-info-label"><i class="pe-7s-user"></i> Username</span>
          <span class="pc-info-val">{{ user?.name || '—' }}</span>
        </div>
        <div class="pc-info-row">
          <span class="pc-info-label"><i class="pe-7s-lock"></i> Account Status</span>
          <span class="pc-info-val pc-status-active">Active</span>
        </div>
        <div class="pc-info-row" *ngIf="user?.clientCode">
          <span class="pc-info-label"><i class="pe-7s-keypad"></i> Client Code</span>
          <span class="pc-info-val">{{ user.clientCode }}</span>
        </div>
      </div>

    </div>

    <!-- RIGHT: stacked cards -->
    <div class="profile-right">

      <!-- Quick Access -->
      <div class="pc-card pc-quickaccess">
        <div class="pc-card-header">
          <i class="pe-7s-rocket"></i>
          <span>Quick Access</span>
        </div>
        <div class="pc-ql-grid">
          <button class="pc-ql-item" *ngFor="let link of quickLinks" type="button" (click)="navigate(link.route)">
            <div class="pc-ql-icon">
              <i [class]="link.icon"></i>
            </div>
            <span class="pc-ql-label">{{ link.label }}</span>
          </button>
        </div>
      </div>

      <!-- Session info -->
      <div class="pc-card pc-session">
        <div class="pc-card-header">
          <i class="pe-7s-info"></i>
          <span>Session Info</span>
        </div>
        <div class="pc-session-body">
          <div class="pc-sess-row">
            <div class="pc-sess-icon"><i class="pe-7s-display2"></i></div>
            <div class="pc-sess-detail">
              <span class="pc-sess-label">Platform</span>
              <span class="pc-sess-val">Web Application</span>
            </div>
          </div>
          <div class="pc-sess-row">
            <div class="pc-sess-icon"><i class="pe-7s-check"></i></div>
            <div class="pc-sess-detail">
              <span class="pc-sess-label">Session</span>
              <span class="pc-sess-val pc-status-active">Active &amp; Authenticated</span>
            </div>
          </div>
          <div class="pc-sess-row">
            <div class="pc-sess-icon"><i class="pe-7s-shield"></i></div>
            <div class="pc-sess-detail">
              <span class="pc-sess-label">Access Level</span>
              <span class="pc-sess-val" [ngClass]="'role-val--' + user?.role?.toLowerCase()">{{ roleLabel }}</span>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>

</div>
